import { loadFromStorage } from './loadFromStorage';

export const isMementoAvailable = (id: string, platform: string) => {
  try {
    // access to localStorage might fail with SecurityError or other funny stuff
    const payload = loadFromStorage(id, platform);
    return payload && Boolean(payload.configurations.length);
  } catch (e) {
    return false;
  }
};
